module.exports = require('./lib/country-query.js')
